export const environment = import.meta.env.VITE_IS_MOBILE ? "mobile" : "desktop";
